export const CONTACT_ROLES = [
  'CONSTRUCTION_COMPANY',
  'ENGINEERING_OFFICE',
  'REAL_ESTATE',
  'LEGAL',
] as const
export type ContactRole = (typeof CONTACT_ROLES)[number]

export const contactRoleFrenchLabel: Record<ContactRole, string> = {
  CONSTRUCTION_COMPANY: 'Entreprise Travaux',
  ENGINEERING_OFFICE: "Bureau d'Etudes",
  REAL_ESTATE: 'Foncier',
  LEGAL: 'Juridique',
}

export const CONTACT_SUBROLES_BY_ROLE = {
  CONSTRUCTION_COMPANY: [
    'STRUCTURAL_WORK',
    'VRD',
    'LOCKSMITHING',
    'WOODEN_CARPENTRY',
    'PAINTING',
    'PLASTERING',
    'FLOORING',
    'TCE',
    'ELECTRICITY',
    'HVAC',
    'PLUMBING',
    'COMMERCIAL_REFRIGERATION',
    'SUPPLIER',
    'RESIN',
    'FITTER',
    'REGULATORY_INSPECTIONS',
    'FIRE_SAFETY',
    'INTRUSION_DETECTION',
    'VIDEO_SURVEILLANCE',
    'CLEANING',
    'GENERAL_CONTRACTOR',
    'MOE',
    'CONTROL_OFFICE',
    'CSPS',
  ],
  ENGINEERING_OFFICE: ['GEOTECHNICIAN', 'SURVEYOR'],
  REAL_ESTATE: ['BAILIFF', 'LANDLORD', 'BUILDING_MANAGER', 'AGENCY', 'OWNER'],
  LEGAL: ['NOTARY', 'LAWYER'],
} as const satisfies Record<ContactRole, readonly string[]>

export type ContactSubrole =
  (typeof CONTACT_SUBROLES_BY_ROLE)[keyof typeof CONTACT_SUBROLES_BY_ROLE][number]

export const CONTACT_SUBROLES = Object.values(CONTACT_SUBROLES_BY_ROLE).flat() as ContactSubrole[]

export const contactSubroleFrenchLabel: Record<ContactSubrole, string> = {
  STRUCTURAL_WORK: 'Gros-Oeuvre',
  VRD: 'VRD',
  LOCKSMITHING: 'Serrurerie',
  WOODEN_CARPENTRY: 'Menuiserie Bois',
  PAINTING: 'Peinture',
  PLASTERING: 'Plâtrerie',
  FLOORING: 'Revêtements de Sol',
  TCE: 'TCE',
  ELECTRICITY: 'Electricité',
  HVAC: 'CVC',
  PLUMBING: 'Plomberie',
  COMMERCIAL_REFRIGERATION: 'Froid Commercial',
  SUPPLIER: 'Fournisseur',
  RESIN: 'Résine',
  FITTER: 'Agenceur',
  REGULATORY_INSPECTIONS: 'Vérifications Réglementaires',
  FIRE_SAFETY: 'Sécurité Incendie',
  INTRUSION_DETECTION: 'Anti-intrusion',
  VIDEO_SURVEILLANCE: 'Vidéo-surveillance',
  CLEANING: 'Nettoyage',
  GENERAL_CONTRACTOR: 'Contractant Général',
  MOE: 'MOE',
  CONTROL_OFFICE: 'Bureau de Contrôle',
  CSPS: 'CSPS',
  GEOTECHNICIAN: 'Géotechnicien',
  SURVEYOR: 'Géomètre',
  BAILIFF: 'Huissier',
  LANDLORD: 'Bailleur',
  BUILDING_MANAGER: 'Syndic',
  AGENCY: 'Agence',
  OWNER: 'Propriétaire',
  NOTARY: 'Notaire',
  LAWYER: 'Avocat',
}
